import React from 'react';

type Context = {
  mobileFilterOpen: boolean;
  setMobileFilterOpen: React.Dispatch<React.SetStateAction<boolean>>;
  count: number;
  setCount: React.Dispatch<React.SetStateAction<number>>;
};

export const FilterContext = React.createContext({} as Context);
